import ChipInButton from './chip_in_button'
import { connect } from 'react-redux'
import { glimpseRoute } from 'lib/route_utils'
import { loginUrlSelector, isLoggedInSelector } from 'redux/selectors/login'
import { getCampaignSelector } from 'redux/selectors/campaign'
import isOwnerSelector from 'redux/selectors/is_owner'
import hasCurrencyBalanceSelector from 'redux/selectors/has_currency_balance'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/send_glimpse/send_confirm')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  let chipInHref = glimpseRoute('send')
  let fullPageRefresh = false
  const hasCurrencyBalance = hasCurrencyBalanceSelector(state, props)
  const { is_p2p_enabled } = state.flags
  if (!isLoggedInSelector(state) && hasCurrencyBalance) {
    chipInHref = window.location.origin + chipInHref
    if (state.send_iframe.gs_bypass) {
      chipInHref += '?gsbps=true'
    }

    const onboardData = {
      'country.x': state.country.country_code,
      'locale.x': state.country.locale,
      intent: 'tesla',
      redirect_url: chipInHref,
      sendMoneyText: i18n('title', {
        name: campaign.owner.full_name,
      }),
    }
    const options = {
      returnUri: chipInHref,
      onboardData: `onboardData=${encodeURIComponent(
        JSON.stringify(onboardData)
      )}`,
      showGuest: state.can_guest,
    }
    chipInHref = loginUrlSelector(options)(state)
    fullPageRefresh = true
  }
  if (!campaign.can_chip_in || !is_p2p_enabled) {
    chipInHref = ''
  }
  const isOwner = isOwnerSelector(state, props)
  return {
    chipInHref,
    fullPageRefresh,
    isOwner,
    is_p2p_enabled,
    canChipIn: campaign.can_chip_in,
    noCurrencyBalance: isOwner && !hasCurrencyBalance,
    preview: campaign.preview,
  }
}
export default connect(mapStateToProps)(ChipInButton)
